import React from 'react'
import {
  Link,
} from "react-router-dom";



function Greeting() {
  return (
    <div className='text-center flex items-center justify-center flex-col min-h-screen w-full'>
        <h1 className='text-4xl'>Welcome to Resume Builder</h1>
        <p className='max-w-3xl mx-auto mt-3'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur dolorum illum quibusdam velit maiores deleniti minus iusto quae, voluptatibus obcaecati enim nihil nemo.</p>
        <Link to='form' className='bg-indigo-400 hover:bg-indigo-500 transition-all text-white px-5 py-3 mt-8 rounded-md'>Generate Resume</Link>
    </div>
  )
}

export default Greeting;